import React from 'react';

import { ImportOnVisibility } from '@lumapps/lumx-suspense/components/ImportOnVisibility';
import { Skeleton } from '@lumapps/play-player/components/Skeleton';

const LazyClientComputedPlay = React.lazy(
    () =>
        import(
            /* webpackChunkName: 'widget-play' */
            './ClientComputedPlay'
        ),
);

export const ClientComputedPlay = (props: React.ComponentProps<typeof LazyClientComputedPlay>) => (
    <ImportOnVisibility loadingFallback={<Skeleton />}>
        <LazyClientComputedPlay {...props} />
    </ImportOnVisibility>
);
